module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_site.7756efa7.webp";